import { REQUEST, FAILURE, SUCCESS } from 'redux-config/reduxHelpers';
import * as actions from './actions';

const initialState = {
  loading: false,
  brandsLoading: false,
  schema: {},
  brands: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_BROKER_COLOR_SCHEMA[REQUEST]:
      return { ...state, loading: true, schema: {} };
    case actions.GET_BROKER_COLOR_SCHEMA[SUCCESS]:
      return { ...state, schema: action.schema, loading: false };
    case actions.GET_BROKER_COLOR_SCHEMA[FAILURE]:
      return { ...state, loading: false };

    case actions.GET_CUSTOMIZATION_BRANDS[REQUEST]:
      return { ...state, brandsLoading: true };
    case actions.GET_CUSTOMIZATION_BRANDS[SUCCESS]:
      return { ...state, brands: action.brands, brandsLoading: false };
    case actions.GET_CUSTOMIZATION_BRANDS[FAILURE]:
      return { ...state, brandsLoading: false };

    default:
      return state;
  }
};

export default reducer;
